import { client } from "./client";

export const fetchComments = async (eventId, page = 1) => {
    const response = await client.get(`/api/events/${eventId}/comments/`, {
        params: { page },
    });
    return response.data;
};

export const createComment = async (eventId, { content, parent = null, mentionedUser = null }) => {
    const payload = { content };
    if (parent) payload.parent = parent;
    if (mentionedUser) payload.mentioned_user = mentionedUser;
    const response = await client.post(`/api/events/${eventId}/comments/`, payload);
    return response.data;
};

export const updateComment = async (eventId, commentId, content) => {
    const response = await client.put(
        `/api/events/${eventId}/comments/${commentId}/`,
        { content },
    );
    return response.data;
};

export const deleteComment = async (eventId, commentId) => {
    const response = await client.delete(
        `/api/events/${eventId}/comments/${commentId}/`,
    );
    return response.data;
};

export const fetchEventReactions = async (eventId) => {
    const response = await client.get(`/api/events/${eventId}/reactions/`);
    return response.data;
};

export const toggleEventReaction = async (eventId, reaction) => {
    const response = await client.post(`/api/events/${eventId}/reactions/`, {
        reaction,
    });
    return response.data;
};

export const toggleCommentReaction = async (eventId, commentId, reaction) => {
    const response = await client.post(
        `/api/events/${eventId}/comments/${commentId}/reactions/`,
        { reaction },
    );
    return response.data;
};
